import { render, staticRenderFns } from "./LayoutList.vue?vue&type=template&id=38da1bb2"
import script from "./LayoutList.vue?vue&type=script&lang=ts"
export * from "./LayoutList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports